const KEYFRAMES = [{ opacity: 0 }];

const DEFAULT_OPTIONS = {
  duration: 300,
  easing: 'ease',
  fill: 'forwards',
};

export default function (htmlElement, options = {}) {
  const closure = (res, rej) => {
    if (!htmlElement) {
      rej('No element specified for fadeOut animation.');
    }

    const animationOptions = {
      ...DEFAULT_OPTIONS,
      ...options,
    };

    const keyframeEffect = new KeyframeEffect(
      htmlElement,
      KEYFRAMES,
      animationOptions,
    );

    const animation = new Animation(keyframeEffect, document.timeline);

    animation.addEventListener('finish', () => {
      res(animation);
    });

    animation.play();
  };

  return new Promise(closure);
}
